import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../Context/UserContextProvider';
import axios from '../../../axios/index';


import styles from "../DashboardFileManagement/DashboardFileManagement.module.css"

export default function FileConsultants(props) {
    const { userToken } = useContext(UserContext);
    const [consultants, setConsultants] = useState([])

    useEffect(() => {
        const getData = async () => {
            const getConsultantData = await axios.get(
                `Estate/EstateConsultant/${props.id}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            setConsultants(getConsultantData.data.data)
        }
        getData()
    }, [userToken, props.id])

    function removeConsultant(id){
        const getConsultantData = axios.post(
            `Estate/RemoveConsultant`,
            {
                "estateId": props.id,
                "consultantId": [id]
            },
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );

        getConsultantData.then(() => {
            let cacheConsultants = consultants.filter((c) => c.id != id);

            setConsultants(cacheConsultants);
        });
    }

    return (
        <>
            <div className='w-100 d-flex align-items-center justify-content-center flex-wrap mt-4 mb-4 px-3'>
                <div className='w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mb-4'>
                    <div className={styles.card_title}>
                        مشاوران فایل
                    </div>
                    <Link to={{
                        pathname: `/share-to-consultant/${props.slug}`,
                        state: props.id
                    }} className={styles.text_blue}>
                        اشتراک گذاری با مشاور
                    </Link>
                </div>

                <div className={`w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap px-2 ${styles.consultants_container}`}>
                    {consultants?.map((item, i) => (
                        <div key={i} className={`d-flex align-items-center justify-content-start my-md-2 my-3 ${styles.consultant_container}`}>
                            <img className={`border-rounded ms-2 ${styles.consultant_profile_img}`} src={`https://backdev.azrmelk.com${item?.imageUrl}`} alt="profile-img" loading='lazy' />
                            <div className="d-flex align-items-start justify-content-center flex-column me-1">
                                <div className={styles.consultant_text1}>
                                    {item.fullName}
                                </div>
                                <div className={styles.consultant_text2}>
                                    {item.education}
                                </div>
                            </div>
                            <a href="#" className='me-3' onClick={(ev) => {removeConsultant(item.id)}}>
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0 0 50 50">
                                    <path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"></path>
                                </svg>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}
